import { Controller } from '@hotwired/stimulus';

// Menu d'actions (<details>) : refermé par Échap (focus rendu au bouton),
// au choix d'un élément, par un clic hors du menu, quand le focus le quitte
// et avant la mise en cache Turbo ; ouvert vers le haut quand il dépasserait
// le bas de son conteneur défilant (ligne d'un tableau) ou de la fenêtre.
export default class extends Controller {
    connect() {
        this.beforeCache = () => this.element.removeAttribute('open');
        document.addEventListener('turbo:before-cache', this.beforeCache);
    }

    disconnect() {
        document.removeEventListener('turbo:before-cache', this.beforeCache);
    }

    close() {
        if (!this.element.open) return;
        this.element.removeAttribute('open');
        this.element.querySelector('summary')?.focus();
    }

    choose() {
        this.element.removeAttribute('open');
    }

    leave(event) {
        if (event.relatedTarget && !this.element.contains(event.relatedTarget)) this.element.removeAttribute('open');
    }

    place() {
        const panel = this.element.querySelector(':scope > div');
        if (!this.element.open || !panel) return;

        ['top', 'bottom', 'margin-bottom'].forEach((property) => panel.style.removeProperty(property));
        const limit = this.clipBottom();
        const rect = panel.getBoundingClientRect();
        const room = this.element.getBoundingClientRect().top;
        if (rect.bottom > limit && room > rect.height) {
            Object.assign(panel.style, { top: 'auto', bottom: '100%', marginBottom: '0.25rem' });
        }
    }

    // Bas visible : celui du premier ancêtre qui rogne (overflow), sinon de
    // la fenêtre.
    clipBottom() {
        let node = this.element.parentElement;
        while (node && node !== document.body) {
            if (getComputedStyle(node).overflowY !== 'visible') return Math.min(node.getBoundingClientRect().bottom, window.innerHeight);
            node = node.parentElement;
        }
        return window.innerHeight;
    }

    outside(event) {
        if (this.element.open && !this.element.contains(event.target)) this.element.removeAttribute('open');
    }
}
